import { useGetUbbConfig } from '#pplx/frontend/apps/ask/queries/billing-queries/ubb-config/useGetUbbConfig.js';
import { useMemo } from 'react';
// Shown while the catalog request is in flight or unavailable. Matches the
// backend `_CATALOG_DEFAULT` fallback.
export const ASI_UBB_CONFIG_DEFAULT = {
    credit_balance_threshold_cents: 0,
    usd_cents_to_credits: 1,
    auto_refill_threshold_cents: 500,
    min_refill_cents: 1000,
    default_refill_cents: 2500,
    default_spending_limit_cents: 20000,
    global_spending_cap_cents: 200000,
};
export const useAsiUbbConfigForConsumer = () => {
    const { data, isLoading } = useGetUbbConfig();
    return useMemo(() => ({
        variation: data?.consumer ?? ASI_UBB_CONFIG_DEFAULT,
        loading: isLoading,
    }), [data, isLoading]);
};
export const useAsiUbbConfigForEnterpriseTier = ({ subscriptionTier, }) => {
    const { data, isLoading } = useGetUbbConfig();
    return useMemo(() => {
        const variation = subscriptionTier === 'max' ? data?.enterprise_max : data?.enterprise_pro;
        return {
            variation: variation ?? ASI_UBB_CONFIG_DEFAULT,
            loading: isLoading,
        };
    }, [data, isLoading, subscriptionTier]);
};
//# sourceMappingURL=useAsiUbbConfig.js.map